import { render, staticRenderFns } from "./BrandPartsComments.vue?vue&type=template&id=683d8120&scoped=true&"
import script from "./BrandPartsComments.vue?vue&type=script&lang=js&"
export * from "./BrandPartsComments.vue?vue&type=script&lang=js&"
import style0 from "./BrandPartsComments.vue?vue&type=style&index=0&id=683d8120&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683d8120",
  null
  
)

export default component.exports